<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import zhTW from "ant-design-vue/es/locale/zh_TW";
import moment from "moment";
import "moment/locale/zh-cn";
import { getBaseSiteConfig } from "@/api/index";

moment.locale("cn");

export default {
  data() {
    return {
      locale: zhTW,
      moment,
      enUS,
      zhCN,
      zhTW,
    };
  },
  created() {
    getBaseSiteConfig()
      .then((res) => {
        if (res.code === 1) {
          this.$store.dispatch("setSiteConfigInfo", res.data);
          document.title = res.data.sitename;
          document.description = res.data.description;
        }
      })
      .catch(() => {});
  },
  methods: {},
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif, PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*
  color: #2c3e50;
  background: #333;
  */
  height: 100%;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
